"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["active", "className", "component", "label", "listItemClassName"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tabs = function Tabs(_ref) {
  var className = _ref.className,
      links = _ref.links,
      listClassName = _ref.listClassName;
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: (0, _classnames.default)("p-tabs", className)
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)("p-tabs__list", listClassName)
  }, links.map(function (link, i) {
    var active = link.active,
        className = link.className,
        component = link.component,
        label = link.label,
        listItemClassName = link.listItemClassName,
        rest = _objectWithoutProperties(link, _excluded);

    var Component = component || "a";
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames.default)("p-tabs__item", listItemClassName),
      key: i
    }, /*#__PURE__*/_react.default.createElement(Component, _extends({
      "aria-selected": active,
      className: (0, _classnames.default)("p-tabs__link", className),
      "data-testid": "tab-link-".concat(label)
    }, rest), label));
  })));
};

var _default = Tabs;
exports.default = _default;